// extracted by mini-css-extract-plugin
module.exports = {"outer":"ACRoundBoxWithDotLayout_outer__8l4wi","dot":"ACRoundBoxWithDotLayout_dot__nvAnv"};